import { __ } from '@wordpress/i18n';
import { useState, useEffect, useRef } from '@wordpress/element';
import {
	Placeholder,
	Button,
	Dashicon,
	Modal,
	CustomSelectControl,
} from '@wordpress/components';
import { useDispatch, useSelect } from '@wordpress/data';

import classnames from 'classnames';

export function getCurrentMedia() {
	let currentDevice = '';
	const store = wp.data.select( 'core/edit-post' );
	if ( typeof store.__experimentalGetPreviewDeviceType === 'function' ) {
		currentDevice = store.__experimentalGetPreviewDeviceType();
	}

	const editor = wp.data.select( 'core/editor' );
	if ( typeof editor.getDeviceType === 'function' ) {
		currentDevice = editor.getDeviceType();
	}
	return currentDevice;
}

export function mediaValueToValue( mediaValue, currentMedia = 'Desktop' ) {
	let _currentMedia = getCurrentMedia()?.toLowerCase();

	console.log(
		'mediaValueToValue mediaValue, _currentMedia',
		mediaValue,
		_currentMedia?.toLowerCase()
	);
	if (
		typeof mediaValue === 'object' &&
		_currentMedia?.toLowerCase() in mediaValue
	) {
		return mediaValue?.[ _currentMedia?.toLowerCase() ];
	}
	return mediaValue;
}

export function valueToMediaValue(
	simpleValue,
	currentMedia = 'Desktop',
	value
) {
	let _currentMedia = getCurrentMedia()?.toLowerCase();

	console.log(
		'valueToMediaValue simpleValue, _currentMedia, value:',
		simpleValue,
		_currentMedia?.toLowerCase(),
		getCurrentMedia(),
		value
	);

	if (
		typeof simpleValue === 'object' &&
		_currentMedia?.toLowerCase() in simpleValue
	) {
		return simpleValue;
	}
	if ( typeof value === 'string' ) {
		return {
			[ _currentMedia?.toLowerCase() ]: simpleValue,
		};
	}

	return {
		...( value || {} ),
		[ _currentMedia?.toLowerCase() ]: simpleValue,
	};
}

// export function useMediaChange(eventType, callback) {
//   useEffect(() => {
//     window.addEventListener(eventType, callback);
//     return () => {
//       window.removeEventListener(eventType, callback);
//     };
//   }, [eventType, callback]);
// }
export function toTitleCase( str ) {
	if ( ! str ) return '';
	return str.charAt( 0 ).toUpperCase() + str.slice( 1 ).toLowerCase();
}

export function mediaChange( media ) {
	// if ( window?.__alphaBlocksCurrentMedia !== media) {
	//     window.__alphaBlocksCurrentMedia = media;
	//     window.dispatchEvent(new CustomEvent('alphaBlocksMediaChange', { detail: media }));
	//     setEditorPreviewSize(media)
	//   }
	// setPreviewDeviceType(toTitleCase(media))
}

// Global media state and event
if ( ! window.__alphaBlocksCurrentMedia ) {
	window.__alphaBlocksCurrentMedia = 'desktop';
}

export function setPreviewDeviceType( _deviceType = 'Desktop' ) {
	let deviceType = toTitleCase( _deviceType );
	const validDevices = [ 'Desktop', 'Tablet', 'Mobile' ];
	if ( ! validDevices.includes( deviceType ) ) {
		return;
	}
	const editPostDispatch = wp.data.dispatch( 'core/edit-post' );

	if ( typeof editPostDispatch.setPreviewDeviceType === 'function' ) {
		editPostDispatch.setPreviewDeviceType( deviceType );
		return;
	}
	if (
		typeof editPostDispatch.__experimentalSetPreviewDeviceType ===
		'function'
	) {
		editPostDispatch.__experimentalSetPreviewDeviceType( deviceType );
		return;
	}
}

const InspectorResponsiveLabel2 = ( props ) => {
	const {
		checked,
		label = '',
		onReset = () => {},
		unites = [],
		defaultUnit = '',
		value,
		currentUnit = '',
		setCurrentUnit = () => {},
		availableMedia = [ 'Desktop', 'Tablet', 'Mobile' ],
		isResetButton = true,
		isMedia = true,
		isUnit = true,
	} = props;
	const [ hideUnusedMedia, setHideUnusedMedia ] = useState( true );

	const deviceType = useSelect( ( select ) => {
		const store = select( 'core/edit-post' );
		const editorStore = select( 'core/editor' );
		let device = '';
		if (
			store &&
			typeof store.__experimentalGetPreviewDeviceType === 'function'
		) {
			device = store.__experimentalGetPreviewDeviceType();
		} else if (
			editorStore &&
			typeof editorStore.getDeviceType === 'function'
		) {
			device = editorStore.getDeviceType();
		}
		return device;
	}, [] );

	const currentMedia = toTitleCase( deviceType ) || 'Desktop';

	const setMedia = ( media ) => {
		setPreviewDeviceType( media );
	};

	const reSet = () => {
		if ( onReset ) {
			onReset();
			if ( defaultUnit ) {
				setCurrentUnit( defaultUnit );
			}
		}
	};

	const options = availableMedia?.map( ( media ) => ( {
		key: media,
		name: (
			<Dashicon
				size="15"
				icon={
					media === 'Desktop'
						? 'desktop'
						: media === 'Tablet'
						? 'tablet'
						: 'smartphone'
				}
			></Dashicon>
		),
		style: {},
	} ) );

	const selectedOption = options.find(
		( option ) => option.key === currentMedia
	);

	return (
		<>
			<div className="flex justify-between mb-2">
				<div className="flex justify-start items-center gap-1">
					<span className="mr-2">{ label }</span>
					{ isMedia && availableMedia?.length > 0 && (
						<CustomSelectControl
							className="unit-select"
							options={ options }
							onChange={ ( { selectedItem } ) =>
								setMedia( selectedItem?.key )
							}
							value={ selectedOption }
							__next40pxDefaultSize
						/>
					) }
				</div>
				<div className="flex justify-end float-right items-center ml-2 text-sm">
					{ isResetButton && (
						<Dashicon
							className="text-gray-400 cursor-pointer transition-colors transition-duration-[300] hover:text-[--wp--preset--color--vivid-cyan-blue]"
							size="15"
							icon="image-rotate"
							onClick={ reSet }
						></Dashicon>
					) }
					<div className="flex items-center justify-center ml-2 text-sm">
						{ isUnit && unites?.length > 0 && (
							<CustomSelectControl
								className="unit-select"
								options={ unites?.map( ( tx ) => ( {
									key: tx,
									name: tx,
									style: {},
								} ) ) }
								onChange={ ( { selectedItem } ) => {
									setCurrentUnit( selectedItem?.key );
								} }
								// value={value?.[currentMedia]?.unit}
								value={ currentUnit }
								__next40pxDefaultSize
							/>
						) }
					</div>
				</div>
			</div>
		</>
	);
};

export default InspectorResponsiveLabel2;
